import { render, staticRenderFns } from "./AdminHost.vue?vue&type=template&id=b6e2fb70&scoped=true&"
import script from "./AdminHost.vue?vue&type=script&lang=js&"
export * from "./AdminHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e2fb70",
  null
  
)

export default component.exports